module.exports = __webpack_public_path__ + "static/media/brand-library.882f19e4.svg";